import React, { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

const Container = styled.div(
  ({ isShow }) => css`
    opacity: 1;
    visibility: ${isShow ? 'unset' : 'hidden'};
    ${
      isShow
      ? css`
        opacity: 1;
        transition: opacity 0.3s, visibility 0.9s linear 0.3s;
      ` : css`
        opacity: 0;
        transition: opacity 0.3s, visibility 0.9s linear 0.3s;
      `
    }
  `
)

const Preloader = () => {
  const [isShow, setShow] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false)
    }, 200)

    return () => clearTimeout(timer)
  }, [])

  return (
    <Container className='preloader' isShow={isShow}>
      <div className='nile-preloader'>
        <div className='logo'>
          <img src='/assets/img/loading-1.svg' alt='' />
        </div>
      </div>
    </Container>
  )
}

export default Preloader
